'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error:', error);
  }, [error]);

  return (
    <div className="error-page">
      <div className="error-content">
        <span className="error-code">500</span>
        <h1>Něco se pokazilo</h1>
        <p>Omlouváme se, ale došlo k neočekávané chybě. Zkuste to prosím znovu.</p>
        <div className="error-actions">
          <button onClick={reset} className="btn-primary">
            Zkusit znovu
          </button>
          <Link href="/" className="btn-secondary">
            Zpět na úvodní stránku
          </Link>
        </div>
      </div>
    </div>
  );
}
